import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { File, LucideAngularModule, X } from 'lucide-angular';
import type { AbonoJustificativaListItem } from '../../services/mobile-frequencia.service';
import { obterArrayFaltasFormatadas } from './abono-justificativa-modal.utils';

/**
 * Modal de detalhes (somente leitura) de um abono/justificativa do histórico.
 * Puramente apresentacional — não faz chamada de API, não tem estado próprio
 * além do que recebe via @Input.
 */
@Component({
  selector: 'app-abono-justificativa-detalhes-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './abono-justificativa-detalhes-modal.component.html'
})
export class AbonoJustificativaDetalhesModalComponent {
  @Input() item: AbonoJustificativaListItem | null = null;
  @Input() tipoFrequencia: 'DIA' | 'AULA' = 'DIA';
  @Output() fechado = new EventEmitter<void>();

  readonly FileIcon = File;
  readonly XIcon = X;

  fechar(): void {
    this.fechado.emit();
  }

  obterArrayFaltasFormatadas(faltas: AbonoJustificativaListItem['faltas']): string[] {
    return obterArrayFaltasFormatadas(faltas, this.tipoFrequencia);
  }
}
